(function() {
  'use strict';

  angular
    .module('inspinia', 
      [
        'ngAnimate', 
        'ngCookies', 
        'ngTouch', 
        'ngSanitize', 
        'ngMessages', 
        'ngAria', 
        'ngResource', 
        'ui.router',           
        'ui.bootstrap',
        'ngStorage',
        'ngMask',
        'toastr',
        'ui-leaflet',
        'summernote',
        'chart.js',
        'ui.select',
        'datePicker',
        'cgBusy'
      ]);
})();

'use strict';

angular.module('inspinia')
  .controller('TicketAssuntoSelecionarController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$http', 'API_INTRANET',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $http, API_INTRANET)
  {
    var vm = this;
    vm.pager = {};
    vm.setPage = setPage;
    vm.registrosOriginal = [];
    vm.registros = null;
    vm.filtro = {};

    vm.init = function()
    {
      vm.listar();
    }

    vm.selecionar = function(assunto)
    {
      $uibModalInstance.close(assunto);
    }

    vm.listar = function()
    {
        vm.consultaPromise = $http.get(API_INTRANET + "/ticketassunto/listar")
        .then(function(response)
        { 
          vm.registrosOriginal = response.data;
          vm.registros = response.data;          
          vm.filtrarPesquisa();
        });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.pesquisa != null && vm.filtro.pesquisa != '')
            {
                if (!vm.registrosOriginal[i].nome.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
                {
                    incluir = false;

                    if (!vm.registrosOriginal[i].categoria.nome.toUpperCase().includes(vm.filtro.pesquisa.toUpperCase()))
                    {
                        incluir = false;
                    }
                    else
                    {
                      incluir = true;
                    }
                }
                else
                {
                  incluir = true;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);        
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('TicketSucessoController', ['$scope', '$state', 'toastr', 'API_INTRANET', '$http', '$uibModal',
      function($scope, $state, toastr, API_INTRANET, $http, $uibModal)
  {
    var vm = this;
    vm.ticketNumero = $state.params.numero;
    vm.solicitanteNome = $state.params.nome;

    vm.init = function()
    {
      //vm.ticketNumero = "5646578979";
      
      if (vm.ticketNumero == null)
      {
        $state.go('index.novo_ticket');
      }
      
    }

    vm.consultarSituacao = function()
    {
      $state.go('index.consultar_ticket');
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('TicketCadastroController', ['$scope', '$compile', '$cookieStore', '$state', 'toastr', 'API_INTRANET', '$http', '$uibModal',
      function($scope, $compile, $cookieStore, $state, toastr, API_INTRANET, $http, $uibModal)
  {
    var vm = this;
    vm.ticket = {
      solicitante: {},
      campos : []
    };

    vm.init = function()
    {
        vm.listarLocalidades();  

        if ($cookieStore.get('last_solicitante_nome') != null)
        {
          vm.ticket.solicitante.nome = $cookieStore.get('last_solicitante_nome');
        }
        if ($cookieStore.get('last_solicitante_email') != null)
        {
          vm.ticket.solicitante.email = $cookieStore.get('last_solicitante_email');
        }
        if ($cookieStore.get('last_solicitante_telefone') != null)
        {
          vm.ticket.solicitante.telefone = $cookieStore.get('last_solicitante_telefone');
        }
        if ($cookieStore.get('last_solicitante_usuario_rede') != null)
        {
          vm.ticket.solicitante.usuarioRede = $cookieStore.get('last_solicitante_usuario_rede');
        }
    }

    vm.salvar = function()
    {
      if (vm.ticket.solicitante.nome == null || vm.ticket.solicitante.nome == '')
      {
        toastr.error('Nome do solicitante é obrigatório', 'Alerta');
        return;
      }

      if (vm.ticket.solicitante.email == null || vm.ticket.solicitante.email == '')
      {
        toastr.error('E-mail do solicitante é obrigatório', 'Alerta');
        return;
      }

      if (vm.ticket.solicitante.telefone == null || vm.ticket.solicitante.telefone == '')
      {
        toastr.error('Telefone é obrigatório', 'Alerta');
        return;
      }

      if (vm.ticket.solicitante.usuarioRede == null || vm.ticket.solicitante.usuarioRede == '')
      {
        toastr.error('Usuário de rede é obrigatório', 'Alerta');
        return;
      }

      vm.salvarPromise = $http.post(API_INTRANET + "/ticket/registrar", vm.ticket).success(function(response){        
        toastr.info('Seu Ticket foi cadastrado com sucesso.', 'Ticket');
        var nomeSolicitante = vm.ticket.solicitante.nome;
        //vm.ticket = { campos : [] };

        $cookieStore.put('last_solicitante_nome', vm.ticket.solicitante.nome);
        $cookieStore.put('last_solicitante_email', vm.ticket.solicitante.email);
        $cookieStore.put('last_solicitante_telefone', vm.ticket.solicitante.telefone);
        $cookieStore.put('last_solicitante_usuario_rede', vm.ticket.solicitante.usuarioRede);
        $cookieStore.put('last_ticket_numero', response);        

        $state.go('index.sucesso_ticket', {numero: response, nome: nomeSolicitante});
        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

    vm.listarLocalidades = function()
    {
      vm.localidadesPromise = $http.get(API_INTRANET + "/localidade/listar")
      .then(function(response)
      { 
        vm.localidades = response.data;
        vm.ticket.localidade = vm.localidades[0];

        vm.listarDepartamentos(vm.ticket.localidade);
      });
    }

    vm.atualizarDepartamentos = function()
    {
      vm.listarDepartamentos(vm.ticket.localidade);
    }

    vm.listarDepartamentos = function(localidade)
    {
      vm.departamentosPromise = $http.get(API_INTRANET + "/inventariodepartamento/listar/" + localidade.id)
      .then(function(response)
      { 
        vm.departamentos = response.data;
        vm.ticket.departamento = vm.departamentos[0];
      });
    }

    vm.selecionarAssunto = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/ticket/modal/selecionar_assunto/index.html',
        controller: 'TicketAssuntoSelecionarController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        resolve: {
          /*
          antecipacao: function () {
              return antecipacao;
          },
          */
        }
      }).result.then(function(data){
        vm.ticket.assunto = data;        
        vm.gerarCampos();
        //vm.listar();
      });
    }

    vm.gerarCampos = function()
    {
      angular.element(document.getElementById('_campos')).html($compile("")($scope));

      if (vm.ticket.assunto != null && vm.ticket.assunto.campos != null)
      {
        for (var i = 0; i < vm.ticket.assunto.campos.length; i++)
        {
          var input = "<div class='row'><div class='col-sm-6'><div class='form-group'><label class='col-form-label'>" + vm.ticket.assunto.campos[i].nome + (vm.ticket.assunto.campos[i].obrigatorio ? " <span class='red'>*</span>" : '') + "</label><input type='text' ng-model='controller.ticket.campos[" + i + "]." + vm.ticket.assunto.campos[i].identificador + "' maxlength='100' class='form-control'></div></div></div>";
          angular.element(document.getElementById('_campos')).append($compile(input)($scope));
        }
      }      
    }

    vm.verificarEmail = function()
    {
      if (vm.ticket.solicitante.email != null && vm.ticket.solicitante.email != '')
      {
        vm.verificarEmailPromise = $http.get(API_INTRANET + "/contato/email/" + vm.ticket.solicitante.email)
        .then(function(response)
        { 
          if(response.data != null && response.data != '')
          {
            toastr.info('Contato encontrado.', 'Alerta');
            vm.ticket.solicitante.nome = response.data.nome;
            vm.ticket.solicitante.telefone = response.data.complemento.telefone;
            vm.ticket.solicitante.usuarioRede = response.data.usuarioRede;
          }
          else
          {
            toastr.error('Contato não encontrado.', 'Alerta');
          }
        });
      }
    }

    vm.verificarUsuarioRede = function()
    {
      if (vm.ticket.solicitante.usuarioRede != null && vm.ticket.solicitante.usuarioRede != '')
      {
        vm.verificarUsuarioRedePromise = $http.get(API_INTRANET + "/contato/usuariorede/" + vm.ticket.solicitante.usuarioRede)
        .then(function(response)
        { 
          if(response.data != null && response.data != '')
          {
            toastr.info('Contato encontrado.', 'Alerta');
            vm.ticket.solicitante.nome = response.data.nome;
            vm.ticket.solicitante.telefone = response.data.complemento.telefone;
            vm.ticket.solicitante.email = response.data.email;
          }
          else
          {
            toastr.error('Contato não encontrado.', 'Alerta');
          }
        });
      }
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('TicketConsultaController', ['$scope', '$state', '$cookieStore', 'toastr', 'API_INTRANET', '$http', '$uibModal',
      function($scope, $state, $cookieStore, toastr, API_INTRANET, $http, $uibModal)
  {
    var vm = this;
    vm.ticket = null;
    vm.ticketViewId = $state.params.viewId;
    vm.avaliacao = 0;   
    vm.filtro = {
      tipoConsulta: '1'
    };

    vm.init = function()
    {
      if ($cookieStore.get('last_ticket_numero') != null)
      {
        vm.filtro.numeroTicket = $cookieStore.get('last_ticket_numero');
      }
      if ($cookieStore.get('last_solicitante_usuario_rede') != null)
      {
        vm.filtro.usuarioRede = $cookieStore.get('last_solicitante_usuario_rede');
      }
    }

    vm.consultar = function()
    {
      vm.tickets = null;

      if (vm.filtro.tipoConsulta == '1')
      {
        if (vm.filtro.numeroTicket == null || vm.filtro.numeroTicket == '')
        {
          toastr.error("Favor informar o número do Ticket.", 'Alerta');
          return; 
        }
      }
      if (vm.filtro.tipoConsulta == '2')
      {
        if (vm.filtro.usuarioRede == null || vm.filtro.usuarioRede == '')
        {
          toastr.error("Favor informar o usuário do rede.", 'Alerta');
          return; 
        }
      }          

      vm.consultarPromise = $http.post(API_INTRANET + "/ticket/listarexterno", vm.filtro).success(function(response){        
        
        vm.tickets = response;        

        if (vm.filtro.usuarioRede != null && vm.filtro.usuarioRede != '')
        {
          $cookieStore.put('last_solicitante_usuario_rede', vm.filtro.usuarioRede);                    
        }

        if (vm.filtro.numeroTicket != null && vm.filtro.numeroTicket != '')
        {          
          $cookieStore.put('last_ticket_numero', vm.filtro.numeroTicket);                      
        }

        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });

      /*
      vm.consultarPromise = $http.get(API_INTRANET + "/ticket/consultarnumero/" + vm.filtro)
      .then(function(response)
      {
        vm.filtro.numeroTicket = "";
        vm.filtro.usuarioRede = "";
        vm.ticket = response.data;        
      }).catch(function(error){
        toastr.error(error.data, 'Alerta');
      });
      */
    }

    vm.setAvaliacao = function(p)
    {
      vm.avaliacao = p;
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('ServicoCatalogoPesquisaController', ['$scope', '$state', '$location', 'toastr', 'API_ROOT', '$http', '$uibModal',
      function($scope, $state, $location, toastr, API_ROOT, $http, $uibModal)
  {
    var vm = this;
    vm.tipoParam = $state.params.tipo;
    vm.filtro = {tipo: 0};

    vm.init = function()
    {        
      vm.s_subdomain();      
    }

    vm.s_subdomain = function()
    {
        var host = $location.host();
        
        if (host.indexOf('.') < 0) 
        {
          vm.subdomain = _teste;          
        }
        else
        {
          var subdomain = host.split('.')[0];

          if (subdomain != '')
          {
            vm.subdomain = subdomain;
          }
        }

        if (vm.subdomain != null && vm.subdomain != '')
        {          
          vm.listarProdutos(vm.subdomain);
        }
    }

    vm.listarProdutos = function(subdomain)
    {
      vm.registros = null;
      vm.registrosOriginal = null;

      vm.consultaPromise = $http.get(API_ROOT + "/catalogoweb/listarProdutos/" + subdomain)
      .then(function(response)
      { 
        vm.registrosOriginal = response.data;

        for(var i=0; i<vm.registrosOriginal.length; i++) {
          vm.registrosOriginal[i].foto = (API_ROOT + "/catalogoweb/ConsultarProdutoFoto/" + vm.registrosOriginal[i].viewId);
        }

        vm.registros = vm.registrosOriginal;
      });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];        

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.texto != null && vm.filtro.texto != '')
            {
              if (!vm.registrosOriginal[i].nome.toUpperCase().includes(vm.filtro.texto.toUpperCase()))
              {
                  incluir = false;
              }
            }

            if (vm.filtro.tipo != null && vm.filtro.tipo != '' && vm.filtro.tipo != '0')
            {
              if (vm.filtro.tipo != vm.registrosOriginal[i].tipo)
              {
                  incluir = false;
              }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('RequisicaoProjetoController', ['$scope', '$compile', '$state', 'toastr', 'API_INTRANET', '$http', '$uibModal',
      function($scope, $compile, $state, toastr, API_INTRANET, $http, $uibModal)
  {
    var vm = this;    
    vm.registro = {};
    
    vm.init = function()
    {
              
    }

    vm.salvar = function()
    {
      vm.salvarPromise = $http.post(API_INTRANET + "/requisicaoprojeto/registrar", vm.registro).success(function(response){        
        toastr.info('Sua requisição foi enviada com sucesso.', 'Ticket');
        //var nomeSolicitante = vm.ticket.solicitante.nome;
        //vm.ticket = { campos : [] };
        //$state.go('index.sucesso_ticket', {numero: response, nome: nomeSolicitante});
        vm.registro = {};
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

  }]);
angular
.module('inspinia').factory("UsuarioService", ['$http', 'API_INTRANET', 'AuthService', 
    function ($http, API_INTRANET, AuthService) {
    return {
        login: function(login, pwd){
            var data = {
                login: login,
                senha: pwd
            }
            return $http.post(API_INTRANET + "/Login", data).then(
                function(response){
                    AuthService.setToken(response.data.accessToken);
                    AuthService.setUser(response.data.userName);
                    AuthService.setEmpresa(response.data.empresa);
                    AuthService.setRole(response.data.role);
                    return response;
                },
                function (error) {
                    return error;
                }
            )
        },
        insert: function(usuario){
            return $http.post(API_INTRANET + "/usuario/registrar", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },
        update: function(viewId, usuario){
            usuario.ViewId = viewId;
            return $http.post(API_INTRANET + "/usuario/update", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },
        updatePassword: function(oldPassword, newPassword){
            usuario = {};
            usuario.oldPassword = oldPassword;
            usuario.newPassword = newPassword;
            return $http.post(API_INTRANET + "/usuario/updatePassword", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },
        delete: function(usuario){
            return $http.post(API_INTRANET + "/usuario/remove", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },       
        get: function (viewId) {
            return $http.get(API_INTRANET + "/usuario/" + viewId)
            .then(function(response)
            { 
                return response.data;
            });
        },
        getAll: function () {
            return $http.get(API_INTRANET + "/usuario/GetAll")
            .then(function(response)
            { 
                return response.data;
            });
        },
        getMenu: function (viewId) {
            return $http.get(API_INTRANET + "/menu")
            .then(function(response)
            { 
                return response.data;
            });
        }
    }
}]);
'use strict';

angular.module('inspinia')
  .controller('UsuarioPesquisaController', ['$scope', '$state', 'UsuarioService', 'toastr', 'PagerService', 'API_INTRANET', '$http',
      function($scope, $state, UsuarioService, toastr, PagerService, API_INTRANET, $http)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.usuarios.length, page);
      vm.items = vm.usuarios.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.pesquisar = function()
    {
      vm.usuariosPromise = $http.get(API_INTRANET + "/usuario/pesquisar")
      .then(function(response)
      { 
        vm.usuarios = response.data;
        vm.pager.totalPages = 1;
        vm.setPage(1);
      });
    }

    vm.incluir = function()
    {
      $state.go('index.cadastrarusuario');
    }

    vm.visualizar = function(usuario)
    {
      $state.go('index.consultarusuario', {obj: usuario});
    }

    vm.alterar = function(usuario)
    {
      $state.go('index.alterarusuario', {obj: usuario});
    }    

    vm.pesquisar();

  }]);
'use strict';

angular.module('inspinia')
  .controller('UsuarioLoginController', ['$scope', '$state', 'toastr', 'AuthService', 
      function($scope, $state, toastr, AuthService)
  {
    var vm = this;

    vm.init = function()
    {
        
    }

    vm.init();

  }]);

'use strict';

angular.module('inspinia')
  .controller('UsuarioCadastroController', ['$scope', '$state', 'UsuarioService', 'API_INTRANET', '$http', 'toastr',
      function($scope, $state, UsuarioService, API_INTRANET, $http, toastr)
{
    var vm = this;

    vm.usuario = {};

    vm.incluir = function()
    {
      vm.salvarPromise = $http.post(API_INTRANET + "/usuario/registrar", vm.usuario).success(function(response){        
        toastr.info('Usuário cadastrado com sucesso!', 'Usuário');
        $state.go('index.pesquisarusuario');
        return response;
      }).error(function(error){
        toastr.error(error, 'Erro no processamento');
        return error;
      });
    }

}]);

'use strict';

angular.module('inspinia')
  .controller('UsuarioAlteracaoSenhaController', ['$scope', '$state', 'UsuarioService', 
      'toastr',
      function($scope, $state, UsuarioService, toastr)
  {
    var vm = this;

    vm.alterar = function()
    {
      var usuarioPromise = UsuarioService.updatePassword(vm.oldPassword, vm.newPassword);

      usuarioPromise.then(function(result) {  
        if (result.data.Status)
        {
          toastr.info('Usuário alterado com sucesso!', 'Usuário');
          $state.go('index.main');
        }
        else
        {
          toastr.error(result.data.Text, 'Usuário');
        }
      });
    }

}]);

'use strict';

angular.module('inspinia')
  .controller('UsuarioAlteracaoController', ['$scope', '$state', 'UsuarioService', 
      'toastr',
      function($scope, $state, UsuarioService, toastr)
  {
    var vm = this;

    vm.usuario = {};
    vm.usuarioParam = $state.params.obj;

    vm.consultar = function()
    {
      var usuarioConsultaPromise = UsuarioService.get(vm.usuarioParam.ViewId);

      usuarioConsultaPromise.then(function(result) {  
        vm.usuario = result;
      });
    }

    vm.alterar = function()
    {
      var usuarioPromise = UsuarioService.update(vm.usuarioParam.ViewId, vm.usuario);

      usuarioPromise.then(function(result) {  
        if (result.data.Status)
        {
          toastr.info('Usuário alterado com sucesso!', 'Usuário');
          $state.go('index.pesquisarusuario');
        }
        else
        {
          toastr.error(result.data.Text, 'Usuário');
        }
      });
    }

    vm.excluir = function()
    {
      var deleteUsuarioPromise = UsuarioService.delete(vm.usuarioParam);

      deleteUsuarioPromise.then(function(result) {  
        if (result.data.Status)
        {
          toastr.info('Usuário excluído com sucesso!', 'Usuário');
          $state.go('index.pesquisarusuario');
        }
        else
        {
          toastr.error(result.data.Text, 'Usuário');
        }
      });
    }

    vm.init = function()
    {
      if (vm.usuarioParam == null)
      {
        $state.go('index.pesquisarusuario');
      }
      else
      {
        vm.consultar();
      }
    }

    vm.init();

}]);

angular.module('inspinia')
    .factory('AuthService', AuthService);

function AuthService ($localStorage, $q) {
    return {
    getToken : function () {
        return $localStorage.tokenSD;
    },
    setToken: function (token) {
        $localStorage.tokenSD = token;
    },
    getUser : function () {
        return $localStorage.userSD;
    },
    setUser: function (user) {
        $localStorage.userSD = user;
    },
    getEmpresa : function () {
        return $localStorage.empresaSD;
    },
    setEmpresa: function (empresa) {
        $localStorage.empresaSD = empresa;
    },
    getRole : function () {
        return $localStorage.roleSD;
    },
    setRole: function (role) {
        $localStorage.roleSD = role;
    },
    getMenu : function () {
        return $localStorage.menu;
    },
    setMenu: function (menu) {
        $localStorage.menu = menu;
    },
    logout : function (data) {
        delete $localStorage.tokenSD;
        delete $localStorage.userSD;
        delete $localStorage.roleSD;
        delete $localStorage.empresaSD;
        $q.when();
    }
    };
}
angular.module('inspinia')
    .factory('AuthInterceptor', AuthInterceptor)
    .config(function($httpProvider) {
    $httpProvider.interceptors.push('AuthInterceptor');
});

function AuthInterceptor ($location, AuthService, $q) {
    return {
    request: function(config) {
        config.headers = config.headers || {};

        if (!config.skipInterceptor && AuthService.getToken()) {
            config.headers['Authorization'] = 'Bearer ' + AuthService.getToken();
        }
        
        return config;
    },

    responseError: function(response) {
        if (response.status === 401 || response.status === 403) {
            $location.path('/login');
        }

        return $q.reject(response);
    }
    }
}
'use strict';

angular.module('inspinia')
  .controller('LoginAppController', ['$scope', '$compile', '$state', 'toastr', 'API_INTRANET', '$http', '$uibModal', '$window',
      function($scope, $compile, $state, toastr, API_INTRANET, $http, $uibModal, $window)
  {
    var vm = this;
    vm.registro = {
      tipoAcesso: '1'
    };
    vm.statusTela = 1;

    vm.init = function()
    {
        
    }

    vm.enviar = function()
    {
      if (vm.registro.usuarioRede == null || vm.registro.usuarioRede == '')
      {
        toastr.error('Informe o seu Usuário de Rede.', 'Alerta');  
        return;
      }

      $state.go('index.home');
      //vm.statusTela = 2;
      /*
      vm.registro.tipoEmpresa = parseInt(vm.registro.tipoEmpresa);

      vm.salvarPromise = $http.post(API_INTRANET + "/cliente/precadastro", vm.registro).success(function(response){        
        toastr.info('Solicitação enviada com sucesso.', 'Ticket');
        vm.registro = {};

        vm.statusTela = 3;

        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
      */
    }

    vm.validarAcesso = function()
    {
      $state.go('index.home');
    }

    vm.voltarInicio = function()
    {
      vm.statusTela = 1;
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('MainController', ['$state', '$location', 'toastr', '$cookieStore', 'API_ROOT', '$http',
  function ($state, $location, toastr, $cookieStore, API_ROOT, $http) {

    var vm = this;
    vm.subdomain = '';

    vm.init = function()
    {
        vm.s_subdomain();
    }

    vm.s_subdomain = function()
    {
      var host = $location.host();
        
      if (host.indexOf('.') < 0) 
      {
        vm.subdomain = _teste;
      }
      else
      {
        var subdomain = host.split('.')[0];

        if (subdomain != '')
        {
          vm.subdomain = subdomain;
        }
      }

      if (vm.subdomain != null && vm.subdomain != '')
      {          
        vm.consultarEmpresa(vm.subdomain);
      }
    }

    vm.consultarEmpresa = function(subdomain)
    {
        vm.consultaPromise = $http.get(API_ROOT + "/catalogoweb/ConsultarEmpresa/" + subdomain)
        .then(function(response)
        { 
          vm.empresa = response.data;
        });
    }

    vm.init();

    /*
    vm.usuario = {};     
    vm.default = '';

    vm.userName = AuthService.getUser();
    vm.empresaName = AuthService.getEmpresa();
    vm.testeuser = 'teste 123'

    vm.init = function()
    {
      if ($cookieStore.get('lastLogin') != null)
      {
        vm.usuario.Login = $cookieStore.get('lastLogin');
      }
    }

    vm.init();

    vm.login = function()
    {
      if (vm.usuario.Login == null || vm.usuario.Login == '')
      {
          toastr.error('Informe o Login da empresa.', 'Login');
          return;
      }

      if (vm.usuario.Senha == null || vm.usuario.Senha == '')
      {
          toastr.error('Informe a Senha.', 'Login');
          return;
      }
     
      $cookieStore.put('lastLogin', vm.usuario.Login);

      vm.loginPromise = vm.realizarLogin(vm.usuario.Login, vm.usuario.Senha);

      vm.loginPromise.then(function(result) {  
          if(result.data.error == null && result.data.authenticated)
          {
              vm.default = result.data.default;

              vm.userName = AuthService.getUser();
              //vm.empresaName = AuthService.getEmpresa();
              //vm.menus = AuthService.getMenu();
              //vm.role = AuthService.getRole();      

              $state.go("index.main");
          }
          else
          {
              toastr.error("Login e/ou senha inválidos.", 'Login');
          }
      });
    }

    vm.realizarLogin = function(login, pwd){
      var data = {
          login: login,
          senha: pwd
      }
      return $http.post(API_INTRANET + "/usuario/login", data).then(
          function(response){
              AuthService.setToken(response.data.accessToken);
              AuthService.setUser(response.data.userName);
              //AuthService.setEmpresa(response.data.empresa);
              //AuthService.setRole(response.data.role);
              return response;
          },
          function (error) {
              return error;
          }
      )
    }
    */

  }]);

'use strict';

angular.module('inspinia')
  .controller('HomeController', ['$state', '$scope', 'toastr', '$uibModal', 'AuthService', 
  function ($state, $scope, toastr, $uibModal, AuthService) {

    var vm = this;

    /*
    vm.init = function()
    {
      vm.userName = AuthService.getUser();
      vm.empresaName = AuthService.getEmpresa();

      vm.indicadoresPromise = AntecipacaoService.getIndicadoresPrincipal();

      vm.indicadoresPromise.then(function(result) {  
        if (result.status)
        {
          vm.indicadores = result.data;
        }
      });

      vm.operacoesPendentesPromise = AntecipacaoService.listarPendentes();

      vm.operacoesPendentesPromise.then(function(result) {  
        if (result.status)
        {
          vm.operacoesPendentes = result.data;
        }
      });
    }

    vm.modalDetalheSolicitacao = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/home/modal/detalhesSolicitacao.html',
        controllerAs: 'arquivoInfo',
        windowClass: 'inmodal',
        size: 'lg',
        resolve: {
         }
      });
    }

    vm.consultarPendentes = function()
    {
      vm.pendentesPromise = AntecipacaoService.getPendentes();

      vm.pendentesPromise.then(function(result) {  
        if (result.status)
        {
          vm.pendentes = result.data;
        }
      });
    }

    vm.init();
    */
   
  }]);

angular
.module('inspinia').factory("HomeService", ['$http', 'APP_ROOT', 'AuthService', 
    function ($http, APP_ROOT, AuthService) {
    return {
        getQuantidade: function () {
            return $http.get(APP_ROOT + "/home/GetQuantidade")
            .then(function(response)
            { 
                return response.data;
            });
        },
        getAtendimentosMapa: function () {
            return $http.get(APP_ROOT + "/home/GetAtendimentosMapa")
            .then(function(response)
            { 
                return response.data;
            });
        },
        getContatosMaps: function () {
            return $http.get(APP_ROOT + "/home/GetContatosMapa")
            .then(function(response)
            { 
                return response.data;
            });
        }
    }
}]);
/**
 * INSPINIA - Responsive Admin Theme
 * 2.7.1
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeight = angular.element('nav.navbar-default').height();
    var wrapperHeight = angular.element('#page-wrapper').height();

    if(navbarHeight > wrapperHeight){
      angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
    }

    if(navbarHeight < wrapperHeight){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeight > wrapperHeight) {
        angular.element('#page-wrapper').css("min-height", navbarHeight  + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

(function() {
  'use strict';

  angular
    .module('inspinia')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('inspinia')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider


      // Index
      .state('i', {
        abstract: true,
        url: "/i",
        templateUrl: "app/components/common/content.html"
      })

      /*
      .state('index.login', {
        url: "/login",
        templateUrl: "app/login/index.html",
        controller: 'LoginAppController',
        controllerAs: 'controller',
      })
      */
      .state('i.h', {
        url: "/h/:tipo",
        templateUrl: "app/home/servico/index.html",
        controller: 'ServicoCatalogoPesquisaController',
        controllerAs: 'controller',
        params: {
          tipo: 'null'
        }
      })
      /*
      .state('index.home2', {
        url: "/home2",
        templateUrl: "app/home/index.html",
        controller: 'TicketCadastroController',
        controllerAs: 'controller',
      })
      .state('index.ticket_projetobi', {
        url: "/ticket_projetobi",
        templateUrl: "app/ticket/custom/projeto_bi/index.html",
        controller: 'TicketCadastroController',
        controllerAs: 'controller',
      })

      // Novo Ticket
      .state('index.novo_ticket', {
        url: "/novo_ticket",
        templateUrl: "app/ticket/novo/index.html",
        controller: 'TicketCadastroController',
        controllerAs: 'controller',
      })
      .state('index.sucesso_ticket', {
        url: "/sucesso_ticket",
        templateUrl: "app/ticket/novo/sucesso.html",
        controller: 'TicketSucessoController',
        controllerAs: 'controller',
        params: {
          numero: null,
          nome: null
        }
      })

      // Consultar Ticket
      .state('index.consultar_ticket', {
        url: "/consultar_ticket",
        templateUrl: "app/ticket/consultar/index.html",
        controller: 'TicketConsultaController',
        controllerAs: 'controller',
      })

      // Requisicao de projetos
      .state('index.requisitar_projeto', {
        url: "/requisitar_projeto",
        templateUrl: "app/gpe/requisicao/index.html",
        controller: 'RequisicaoProjetoController',
        controllerAs: 'controller',
      })

       // Catalogo de servicos
       .state('index.servico_catalogo', {
        url: "/servico_catalogo",
        templateUrl: "app/servico/catalogo/index.html",
        controller: 'ServicoCatalogoPesquisaController',
        controllerAs: 'controller',
      })
            // landing
      .state('landing', {
        url: "/landing",
        templateUrl: "app/landing/landing.html",
        data: { pageTitle: 'Landing page', specialClass: 'landing-page' }
      })

      .state('login', {
        abstract: true,
        url: "/login",
        controller: 'UsuarioLoginController',
        controllerAs: 'usuarioLogin',
        templateUrl: "app/usuario/autenticar.html"
      })

      .state('index.main', {
        url: "/main",
        templateUrl: "app/main/main.html",
        controller: 'HomeController',
        controllerAs: 'home',
        data: { pageTitle: 'Dashboard de Projetos' }
      })

      // REGISTRAR
      .state('portal', {
        abstract: true,
        url: "/portal",
        templateUrl: "app/minor/minor.html",
        controller: 'TicketCadastroController',
        controllerAs: 'controller',
      })
      .state('portal.home', {        
        url: "/home",        
      })

      // Login
      .state('login.autenticar', {
        url: "/autenticar",
        controller: 'UsuarioLoginController',
        controllerAs: 'usuarioLogin',
        templateUrl: "app/usuario/autenticar.html"
      })
      */
      /*
      // Cedente
      .state('index.cadastrar_cedente', {
        url: "/cadastrar_cedente",
        templateUrl: "app/cedente/cadastrar.html",
        controller: 'CedenteCadastroController',
        controllerAs: 'controller'
      })
      .state('index.pesquisar_cedente', {
        url: "/pesquisar_cedente",
        templateUrl: "app/cedente/pesquisar.html",
        controller: 'CedentePesquisarController',
        controllerAs: 'controller'
      })
      .state('index.consultar_cedente', {
        url: "/consultar_cedente/:viewId",
        templateUrl: "app/cedente/consultar.html",
        controller: 'CedenteConsultarController',
        controllerAs: 'controller',
        params: {
          viewId: null
        }
      })

      // Usuarios
      .state('index.pesquisarusuario', {
        url: "/pesquisarusuario",
        templateUrl: "app/usuario/pesquisar.html",
        controller: 'UsuarioPesquisaController',
        controllerAs: 'usuarioPesquisa',
        data: { pageTitle: 'Pesquisar usuários' }
      })
      .state('index.cadastrarusuario', {
        url: "/cadastrarusuario",
        templateUrl: "app/usuario/cadastrar.html",
        controller: 'UsuarioCadastroController',
        controllerAs: 'usuarioCadastro',
        data: { pageTitle: 'Cadastrar Usuário' }
      })
      .state('index.alterarusuario', {
        url: "/alterarusuario",
        templateUrl: "app/usuario/alterar.html",
        controller: 'UsuarioAlteracaoController',
        controllerAs: 'usuarioAlteracao',
        params: {
          obj: null
        },
        data: { pageTitle: 'Editar Usuário' }
      })
      .state('index.alterarsenha', {
        url: "/alterarsenha",
        templateUrl: "app/usuario/alterarsenha.html",
        controller: 'UsuarioAlteracaoSenhaController',
        controllerAs: 'usuarioAlteracaoSenha',
        data: { pageTitle: 'Alterar Senha' }
      });
      */
      $urlRouterProvider.otherwise('/i/h/home');
      //$urlRouterProvider.otherwise('/index/login');
  }

})();

var _teste = '______';

angular
.module('inspinia')
.factory('PagerService', PagerService)

//.constant('API_ROOT', "http://localhost:5000/api")
//.constant('API_ROOT', "http://localhost:44376/api")
//.constant('API_ROOT', "https://customers0001.azurewebsites.net/api")
//.constant('API_ROOT', "https://clientesapp.com/v3/api")

//.constant('API_INTRANET', "http://localhost:5000/api")

//.constant('API_ROOT', "https://apiclientesapp.azurewebsites.net/api")
//.constant('API_INTRANET', "https://apiclientesapp.azurewebsites.net/api")

//.constant('API_ROOT', "https://clientesapp.com/v4/api")

// 24/06/2023 - V5 - catalog - max 2 poolsize
.constant('API_ROOT', "https://api4.clientesapp.com/v5cat/api")

function PagerService() {
    // service definition
    var service = {};

    service.GetPager = GetPager;

    return service;

    // service implementation
    function GetPager(totalItems, currentPage, pageSize) {
        // default to first page
        currentPage = currentPage || 1;

        // default page size is 5
        pageSize = pageSize || 20;

        // calculate total pages
        var totalPages = Math.ceil(totalItems / pageSize);

        var startPage, endPage;
        if (totalPages <= 10) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }

        // calculate start and end item indexes
        var startIndex = (currentPage - 1) * pageSize;
        var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        // create an array of pages to ng-repeat in the pager control
        var pages = _.range(startPage, endPage + 1);

        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    }
};

angular.module('inspinia').value('cgBusyDefaults',{
    message:'Carregando',
    templateUrl: 'app/components/common/loading.html'
  });

angular.module('inspinia').directive('icheck', icheck);

angular.module('inspinia')
.config( [
    '$compileProvider',
    function( $compileProvider )
    {   
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|chrome-extension|data|image):/);
        // Angular before v1.2 uses $compileProvider.urlSanitizationWhitelist(...)
    }
]);

/**
 * icheck - Directive for custom checkbox icheck
 */
function icheck($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, $attrs, ngModel) {
            return $timeout(function() {
                var value;
                value = $attrs['value'];

                $scope.$watch($attrs['ngModel'], function(newValue){
                    $(element).iCheck('update');
                })

                return $(element).iCheck({
                    checkboxClass: 'icheckbox_square-green',
                    radioClass: 'iradio_square-green'

                }).on('ifChanged', function(event) {
                        if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                            $scope.$apply(function() {
                                return ngModel.$setViewValue(event.target.checked);
                            });
                        }
                        if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                            return $scope.$apply(function() {
                                return ngModel.$setViewValue(value);
                            });
                        }
                    });
            });
        }
    };
}

var angles = angular.module("angles", []);

  angles.chart = function (type) {
      return {
          restrict: "A",
          scope: {
              data: "=",
              options: "=",
              id: "@",
              width: "=",
              height: "=",
              resize: "=",
              chart: "@",
              segments: "@",
              responsive: "=",
              tooltip: "=",
              legend: "="
          },
          link: function ($scope, $elem) {
              var ctx = $elem[0].getContext("2d");
              var autosize = false;

              $scope.size = function () {
                  if ($scope.width <= 0) {
                      $elem.width($elem.parent().width());
                      ctx.canvas.width = $elem.width();
                  } else {
                      ctx.canvas.width = $scope.width || ctx.canvas.width;
                      autosize = true;
                  }

                  if($scope.height <= 0){
                      $elem.height($elem.parent().height());
                      ctx.canvas.height = ctx.canvas.width / 2;
                  } else {
                      ctx.canvas.height = $scope.height || ctx.canvas.height;
                      autosize = true;
                  }
              }

              $scope.$watch("data", function (newVal, oldVal) {
                  if(chartCreated)
                      chartCreated.destroy();

                  // if data not defined, exit
                  if (!newVal) {
                      return;
                  }
                  if ($scope.chart) { type = $scope.chart; }

                  if(autosize){
                      $scope.size();
                      chart = new Chart(ctx);
                  };

                  if($scope.responsive || $scope.resize)
                      $scope.options.responsive = true;

                  if($scope.responsive !== undefined)
                      $scope.options.responsive = $scope.responsive;

                  chartCreated = chart[type]($scope.data, $scope.options);
                  chartCreated.update();
                  if($scope.legend)
                      angular.element($elem[0]).parent().after( chartCreated.generateLegend() );
              }, true);

              $scope.$watch("tooltip", function (newVal, oldVal) {
                  if (chartCreated)
                      chartCreated.draw();
                  if(newVal===undefined || !chartCreated.segments)
                      return;
                  if(!isFinite(newVal) || newVal >= chartCreated.segments.length || newVal < 0)
                      return;
                  var activeSegment = chartCreated.segments[newVal];
                  activeSegment.save();
                  activeSegment.fillColor = activeSegment.highlightColor;
                  chartCreated.showTooltip([activeSegment]);
                  activeSegment.restore();
              }, true);

              $scope.size();
              var chart = new Chart(ctx);
              var chartCreated;
          }
      }
  }


  /* Aliases for various chart types */
  angles.directive("chart", function () { return angles.chart(); });
  angles.directive("linechart", function () { return angles.chart("Line"); });
  angles.directive("barchart", function () { return angles.chart("Bar"); });
  angles.directive("radarchart", function () { return angles.chart("Radar"); });
  angles.directive("polarchart", function () { return angles.chart("PolarArea"); });
  angles.directive("piechart", function () { return angles.chart("Pie"); });
  angles.directive("doughnutchart", function () { return angles.chart("Doughnut"); });
  angles.directive("donutchart", function () { return angles.chart("Doughnut"); });
'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('inspinia')
    .directive('icheck', icheck)
    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function() {
                    $timeout(function() {
                        element.metisMenu();
                    });
                });

                // Colapse menu in mobile mode after click on element
                var menuElement = angular.element('#side-menu a:not([href$="\\#"])');
                menuElement.click(function(){
                  if (angular.element(window).width() < 769) {
                    angular.element("body").toggleClass("mini-navbar");
                  }
                });

                // Enable initial fixed sidebar
                if (angular.element("body").hasClass('fixed-sidebar')) {
                  var sidebar = element.parent();
                  sidebar.slimScroll({
                    height: '100%',
                    railOpacity: 0.9
                  });
                }

            }
        };
    })
    .directive('minimalizaSidebar', function ($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-success " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    })
    .directive("fileread", [function () {
        return {
            scope: {
                fileread: "="
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    var reader = new FileReader();
                    reader.onload = function (loadEvent) {
                        scope.$apply(function () {
                            scope.fileread = loadEvent.target.result;
                        });
                    }
                    reader.readAsDataURL(changeEvent.target.files[0]);
                });
            }
        }
    }])
    .directive("setModelOnChange", function() {
        return {
            require: "ngModel",
            link: function postLink(scope,elem,attrs,ngModel) {
            elem.on("change", function(e) {
                console.log("on change (from directive)", e);  
                var files = elem[0].files;
                ngModel.$setViewValue(files);
            })
            }
        }
    })
;

/**
 * icheck - Directive for custom checkbox icheck
 */
function icheck($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, $attrs, ngModel) {
            return $timeout(function() {
                var value;
                value = $attrs['value'];

                $scope.$watch($attrs['ngModel'], function(newValue){
                    $(element).iCheck('update');
                })

                return $(element).iCheck({
                    checkboxClass: 'icheckbox_square-green',
                    radioClass: 'iradio_square-green'

                }).on('ifChanged', function(event) {
                        if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                            $scope.$apply(function() {
                                return ngModel.$setViewValue(event.target.checked);
                            });
                        }
                        if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                            return $scope.$apply(function() {
                                return ngModel.$setViewValue(value);
                            });
                        }
                    });
            });
        }
    };
}
angular.module("inspinia").run(["$templateCache", function($templateCache) {$templateCache.put("app/home/index.html","<style>\r\n    .bigText {\r\n      font-size: 42px !important;\r\n      height: 80px;\r\n      text-align: center;\r\n    }\r\n</style><div class=\"container\"><div class=\"wrapper wrapper-content ng-scope\" style=\"padding-top: 0px; padding-bottom: 0px;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-12\"></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><div style=\"margin-left: 20px; margin-top: 0px; margin-bottom: 0px; text-align: center;\"><img width=\"420px\" src=\"../../assets/images/icons/index3.jpg\"></div><h1 style=\"text-align: center; font-size: 36px;\">Como podemos ajudar?</h1></div></div></div><div style=\"height: 20px;\"></div><div class=\"row\"><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 0;\"><div class=\"ibox-content\" style=\"padding: 10px;\"><a href=\"#/index/novo_ticket\"><div class=\"widget white-bg p-lg text-center\"><div class=\"m-b-md\"><div style=\"height: 10px;\"></div><i class=\"fa fa-tag fa-4x\" style=\"color: steelblue;\"></i><div style=\"height: 20px;\"></div><h3 class=\"font-bold no-margins\">Abertura de Ticket</h3><div style=\"height: 30px;\"><small>Abertura de chamado para a área de tecnologia</small></div></div></div></a></div></div></div><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 0;\"><div class=\"ibox-content\" style=\"padding: 10px;\"><a href=\"#/index/consultar_ticket\"><div class=\"widget white-bg p-lg text-center\"><div class=\"m-b-md\"><div style=\"height: 10px;\"></div><i class=\"fa fa-list fa-4x\" style=\"color: steelblue;\"></i><div style=\"height: 20px;\"></div><h3 class=\"font-bold no-margins\">Minhas Solicitações</h3><div style=\"height: 30px;\"><small>Acompanhe suas solicitações</small></div></div></div></a></div></div></div><div class=\"col-lg-3\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 0;\"><div class=\"ibox-content\" style=\"padding: 10px;\"><a href=\"#/index/ticket_projetobi\"><div class=\"widget white-bg p-lg text-center\"><div class=\"m-b-md\"><div style=\"height: 10px;\"></div><i class=\"fa fa-line-chart fa-4x\" style=\"color: steelblue;\"></i><div style=\"height: 20px;\"></div><h3 class=\"font-bold no-margins\">Solicitar Projeto BI</h3><div style=\"height: 30px;\"><small>Serviços disponíveis</small></div></div></div></a></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/main.html","<div class=\"wrapper wrapper-content ng-scope\"></div>");
$templateCache.put("app/minor/minor.html","");
$templateCache.put("app/login/index.html","<style>\r\n    .bigText {\r\n      font-size: 42px !important;\r\n      height: 80px;\r\n      text-align: center;\r\n    }\r\n</style><div class=\"container\"><div class=\"wrapper wrapper-content ng-scope\" style=\"padding-top: 0px; padding-bottom: 0px;\"><div class=\"row\" ng-if=\"controller.statusTela == 1\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-title gray-bg\"><h5><i class=\"fa fa-home\"></i> Identificação</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><div style=\"margin-left: 20px; margin-top: 16px; margin-bottom: 30px;\"><img width=\"220px\" src=\"https://designing-world.com/apland-4.5.0/img/bg-img/hero-4.png\"></div></div></div><div class=\"col-sm-9\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><div style=\"margin-top: 20px;\"><h2 style=\"font-family: \'Poppins\', sans-serif; font-weight: 600; font-size: 3rem;\">Olá, Bem vindo!</h2><p>Informe os dados abaixo para realizar o acesso ao portal de serviços.</p></div></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><div style=\"margin-top: 0px;\">&nbsp;</div><label class=\"col-form-label\">Opção de Acesso <span class=\"red\">*</span></label><select class=\"form-control inputDisabledModal\" ng-model=\"controller.registro.tipoAcesso\"><option value=\"1\">Usuário de Rede</option></select></div></div></div><div class=\"row\" ng-if=\"controller.registro.tipoAcesso == 1\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Usuário de Rede <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"150\" placeholder=\"Ex: X0000001\" ng-model=\"controller.registro.usuarioRede\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\" ng-if=\"controller.registro.tipoAcesso == 2\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail cadastrado <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"150\" placeholder=\"Ex: usuario@gmail.com\" ng-model=\"controller.registro.email\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Senha <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"12\" placeholder=\"*******\" ng-model=\"controller.registro.email\" class=\"form-control inputDisabledModal\"></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"form-group\" style=\"text-align: right;\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"min-width: 240px;\" ng-click=\"controller.enviar()\"><i class=\"fa fa-arrow-right\"></i> Continuar</button></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.statusTela == 2\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-title gray-bg\"><h5><i class=\"fa fa-home\"></i> Verificação</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><div style=\"margin-left: 20px; margin-top: 16px; margin-bottom: 30px;\"><img width=\"220px\" src=\"https://designing-world.com/apland-4.5.0/img/bg-img/hero-4.png\"></div></div></div><div class=\"col-sm-9\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><div style=\"margin-top: 20px;\"><h2 style=\"font-family: \'Poppins\', sans-serif; font-weight: 600; font-size: 3rem;\">Validação de Acesso</h2><p>Informe o código de acesso enviado no e-mail <b>{{ controller.registro.email }}</b>.</p></div></div></div></div><div class=\"row\" ng-if=\"controller.registro.tipoAcesso == 1\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Código de Acesso <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"4\" placeholder=\"0000\" ng-model=\"controller.registro.codigoAcesso\" class=\"form-control inputDisabledModal bigText\"></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"form-group\" style=\"text-align: right;\"><button class=\"btn btn-md btn-warning\" type=\"button\" style=\"min-width: 180px;\" ng-click=\"controller.voltarInicio()\"><i class=\"fa fa-arrow-left\"></i> Voltar</button> <button class=\"btn btn-md btn-success\" type=\"button\" style=\"min-width: 180px;\" ng-click=\"controller.validarAcesso()\"><i class=\"fa fa-arrow-right\"></i> Continuar</button></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.statusTela == 4\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-title gray-bg\"><h5><i class=\"fa fa-bank\"></i> Formulário de cadastro</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ <span class=\"red\">*</span></label> <input type=\"text\" mask=\"99.999.999/9999-99\" maxlength=\"50\" disabled=\"\" placeholder=\"CNPJ\" ng-model=\"controller.registro.cnpj\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Segmento <span class=\"red\">*</span></label><select disabled=\"\" class=\"form-control inputDisabledModal\" ng-model=\"controller.registro.tipoEmpresa\"><option value=\"1\">Factoring</option><option value=\"2\">Securitizadora</option><option value=\"3\">FIDC</option><option value=\"4\">ESC</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Razão social <span class=\"red\">*</span></label> <input type=\"text\" placeholder=\"\" maxlength=\"200\" ng-model=\"controller.registro.razaoSocial\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Telefone para contato <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"20\" mask=\"(99)99999-9999\" ng-model=\"controller.registro.telefone\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"50\" mask=\"99999-999\" ng-model=\"controller.registro.Cep\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome do responsável pelo cadastro <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"200\" ng-model=\"controller.registro.responsavelNome\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CPF do responsável <span class=\"red\">*</span></label> <input type=\"text\" mask=\"999.999.999-99\" maxlength=\"50\" ng-model=\"controller.registro.responsavelCpf\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cargo/Função</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.responsavelCargo\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"150\" ng-model=\"controller.registro.email\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Confirme seu e-mail <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"150\" ng-model=\"controller.registro.confirmarEmail\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Senha para acesso <span class=\"red\">*</span></label> <input type=\"password\" maxlength=\"10\" ng-model=\"controller.registro.senha\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Confirme sua senha <span class=\"red\">*</span></label> <input type=\"password\" maxlength=\"10\" ng-model=\"controller.registro.confirmarSenha\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><button class=\"btn btn-md btn-warning\" type=\"button\" style=\"min-width: 160px;\" ng-click=\"controller.irInicio()\"><i class=\"fa fa-arrow-left\"></i> Voltar</button></div></div><div class=\"col-lg-9\"><div class=\"form-group\" style=\"text-align: right;\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"min-width: 240px;\" ng-click=\"controller.enviar()\"><i class=\"fa fa-arrow-right\"></i> Enviar Cadastro</button></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.statusTela == 3\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-title gray-bg\"><h5><i class=\"fa fa-edit\"></i> Confirmação</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><div style=\"margin-top: 16px; margin-bottom: 30px;\"><h2>Parabéns, recebemos sua solicitação com sucesso.<br><br>Enviamos uma <b style=\"color: red;\">confirmação</b> para o e-mail informado e o procedimento para acesso.</h2></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"form-group\" style=\"text-align: right;\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"min-width: 240px;\" ng-click=\"controller.irLogin()\"><i class=\"fa fa-arrow-right\"></i> Ir para a tela de Login</button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/usuario/alterar.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Alterar Usuário</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Usuário</a></li><li class=\"active\"><strong>Alterar</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Informações</h5></div><div class=\"ibox-content\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioAlteracao.usuario.Nome\" placeholder=\"Nome completo\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Login</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioAlteracao.usuario.Login\" placeholder=\"Login para acesso\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioAlteracao.usuario.Email\" placeholder=\"E-mail\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Telegram</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioAlteracao.usuario.TelegramUser\" placeholder=\"Usuário do Telegram\" class=\"form-control\"></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"usuarioAlteracao.alterar()\">ATUALIZAR</button></div></div></div></div></div>");
$templateCache.put("app/usuario/alterarsenha.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Alterar Senha</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Usuário</a></li><li class=\"active\"><strong>Alterar Senha</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Alteração de Senha</h5></div><div class=\"ibox-content\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Senha antiga</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioAlteracaoSenha.oldPassword\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nova senha</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioAlteracaoSenha.newPassword\" class=\"form-control\"></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"usuarioAlteracaoSenha.alterar()\">ATUALIZAR</button></div></div></div></div></div>");
$templateCache.put("app/usuario/autenticar.html","<style>\r\n    /*\r\n    body \r\n    {\r\n        zoom: 100%;\r\n        background-image: url(\'https://i2.wp.com/crat.org/wp-content/uploads/2018/08/Webpage-backdrop.jpg\');\r\n        background-repeat:no-repeat;\r\n        background-size:cover;\r\n    }\r\n    */\r\n    body \r\n    {\r\n        background-color: #f3f3f4 !important;\r\n    }\r\n</style><div class=\"middle-box text-center animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"padding-bottom: 10px; margin-top: 100px;\"><div style=\"padding-right: 35px; padding-left: 35px;\"><div style=\"margin-top: 30px;\"><h1 class=\"logo-name\">INF</h1></div><br><br><h5>SERVICE DESK</h5><p>Informe seu login e senha para autenticar</p><form class=\"m-t\" role=\"form\" cg-busy=\"main.loginPromise\"><div class=\"form-group\"><input ng-model=\"main.usuario.Login\" type=\"text\" class=\"form-control\" placeholder=\"Usuário\" required=\"\"></div><div class=\"form-group\"><input ng-model=\"main.usuario.Senha\" type=\"password\" class=\"form-control\" placeholder=\"Senha\" required=\"\"></div><button type=\"submit\" ng-click=\"main.login()\" class=\"btn btn-success block full-width m-b\">Acessar</button></form><p class=\"m-t\"><small>Service Desk &copy; 2020</small></p></div></div></div></div></div></div>");
$templateCache.put("app/usuario/cadastrar.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Cadastrar Usuário</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Usuário</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Dados do Usuário</h5></div><div class=\"ibox-content\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-6\"><input type=\"text\" ng-model=\"usuarioCadastro.usuario.Nome\" placeholder=\"Nome completo\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-4\"><input type=\"text\" ng-model=\"usuarioCadastro.usuario.Email\" placeholder=\"E-mail\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Senha</label><div class=\"col-lg-4\"><input type=\"password\" ng-model=\"usuarioCadastro.usuario.Password\" placeholder=\"Senha\" class=\"form-control\"></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"usuarioCadastro.incluir()\">SALVAR</button></div></div></div></div></div>");
$templateCache.put("app/usuario/pesquisar.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Pesquisar Usuário</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Usuário</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"><a class=\"btn btn-sm btn-success\" ng-click=\"usuarioPesquisa.incluir()\">NOVO USUÁRIO</a></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Usuários</h5></div><div class=\"ibox-content\" cg-busy=\"usuarioPesquisa.usuariosPromise\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 40%\">Nome</th><th style=\"width: 30%\">E-mail</th><th style=\"width: 20%\">Data Cadastro</th><th style=\"width: 10%\">Situação</th></tr></thead><tbody><tr ng:repeat=\"p in usuarioPesquisa.items\"><td>{{p.nome}}</td><td>{{p.email}}</td><td>{{ p.dataCadastro | date: \'dd/MM/yyyy HH:mm\' }}</td><td>{{p.ativo ? \'Ativo\' : \'Inativo\'}}</td><td style=\"text-align: center; width: 1px; white-space: nowrap;\"><a ng-click=\"usuarioPesquisa.alterar(p)\" class=\"btn btn-xs btn-warning\"><i class=\"fa fa-edit\"></i> Editar</a></td></tr></tbody></table></div><ul ng-if=\"usuarioPesquisa.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === 1}\"><a ng-click=\"usuarioPesquisa.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === 1}\"><a ng-click=\"usuarioPesquisa.setPage(usuarioPesquisa.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in usuarioPesquisa.pager.pages\" ng-class=\"{active:usuarioPesquisa.pager.currentPage === page}\"><a ng-click=\"usuarioPesquisa.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === usuarioPesquisa.pager.totalPages}\"><a ng-click=\"usuarioPesquisa.setPage(usuarioPesquisa.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === usuarioPesquisa.pager.totalPages}\"><a ng-click=\"usuarioPesquisa.setPage(usuarioPesquisa.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/home/modal/detalhesSolicitacao.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">×</span><span class=\"sr-only\">Fechar</span></button><h4 class=\"modal-title\">Empresa ABCD Ltda.</h4><small class=\"font-bold\">Detalhes da solicitação de antecipação de recebíveis.</small></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" value=\"Empresa ABCD Ltda.\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" value=\"01.203.423/0001-45\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" value=\"010002-100\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Endereço</label> <input type=\"text\" value=\"Rua Boa Vista, 230\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" value=\"São Paulo\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">UF</label> <input type=\"text\" value=\"SP\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"text\" value=\"R$ 50.000,00\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Prazo</label> <input type=\"text\" value=\"90 dias\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Descrição da proposta</label> <input type=\"text\" value=\"\" class=\"form-control\"></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary\">Enviar Proposta</button></div></div>");
$templateCache.put("app/components/common/content.html","<div ng-include=\"\'app/components/common/topnavbar.html\'\"></div><div ui-view=\"\"></div>");
$templateCache.put("app/components/common/footer.html","<div class=\"footer\"><div class=\"pull-right\">Service Desk 0.1</div><div><strong>Copyright</strong> Service Desk &copy; 2020</div></div>");
$templateCache.put("app/components/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/components/common/loading.html","<div style=\"background-image:url(\'assets/images/icons/loading.gif\');background-size: 50px 50px;margin: 0 auto;background-position:50% 20px;background-repeat:no-repeat\"></div>");
$templateCache.put("app/components/common/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"profile-element\" uib-dropdown=\"\"><div style=\"text-align: center;\"><img alt=\"image\" width=\"100px\" class=\"img-circle\" src=\"assets\\images\\icons\\icon_rb.png\"> <span class=\"block m-t-md\"><strong class=\"font-bold\" style=\"color: white;\">Usuário</strong></span> <span class=\"text-muted text-xs block\">Administrador</span></div></div><div class=\"logo-element\">GRU</div></li><li ui-sref-active=\"active\"><a ui-sref=\"index.main\" href=\"#/index/main\"><i class=\"fa fa-home\"></i> <span class=\"nav-label\">Home</span></a></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-tasks\"></i> <span class=\"nav-label\">Tickets</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.pendentes_ticket\">Pendentes</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.pesquisa_ticket\">Pesquisar Histórico</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.cadastro_ticket\">Registrar Novo Ticket</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-wrench\"></i> <span class=\"nav-label\">Configurações</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li class=\"active\"><a href=\"#\" id=\"damian\" aria-expanded=\"true\">Ticket <span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level collapse in\" aria-expanded=\"true\" style=\"\"><li><a ui-sref=\"index.ticket_assunto_pesquisa\">Assuntos</a></li><li><a ui-sref=\"index.ticket_categoria_pesquisa\">Categorias</a></li><li><a ui-sref=\"index.localidade_pesquisa\">Localidades</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"index.pesquisarusuario\">Usuários</a></li></ul></li></ul></div></nav>");
$templateCache.put("app/components/common/topnavbar.html","<div class=\"container\"><div class=\"wrapper wrapper-content ng-scope\" style=\"padding-top: 15px; padding-bottom: 0px;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-content\" style=\"padding: 0px; padding-bottom: 5px; padding-top: 10px; padding-left: 20px;\"><h1 style=\"font-size: 20px; font-weight: 500; font-family: -apple-system, BlinkMacSystemFont, \'Segoe UI\', Roboto, Oxygen, Ubuntu, Cantarell, \'Open Sans\', \'Helvetica Neue\', sans-serif;\"><table style=\"padding: 0;\"><tr><td ng-if=\"main.empresa.logoBase64 != null && main.empresa.logoBase64 != \'\'\"><img src=\"data:image/png;base64,{{main.empresa.logoBase64}}\" width=\"50px\" alt=\"Logotipo\" style=\"padding-right: 0px; margin-right: 15px;\"></td><td><div style=\"font-size: 16px;\">{{main.empresa.nome}}</div><div style=\"font-size: 12px; padding-top: 3px;\"></div></td></tr></table></h1></div><div class=\"darkblue-bg\" style=\"font-size: 15px; font-family: -apple-system, BlinkMacSystemFont, \'Segoe UI\', Roboto, Oxygen, Ubuntu, Cantarell, \'Open Sans\', \'Helvetica Neue\', sans-serif;\"><div class=\"row\"><div class=\"col-lg-2\"><div style=\"margin-top: 10px; margin-bottom: 10px; text-align: center\"><a href=\"#/index/home\" style=\"color: white;\"><i class=\"fa fa-home\"></i> Home</a></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/home/servico/index.html","<style>\r\n    .bigText {\r\n      font-size: 42px !important;\r\n      height: 80px;\r\n      text-align: center;\r\n    }\r\n</style><div class=\"container\"><div class=\"wrapper wrapper-content ng-scope\" style=\"padding-top: 0px; padding-bottom: 0px;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-title gray-bg\"><h5><i class=\"fa fa-home\"></i> Catálogo</h5></div><div class=\"ibox-content\" style=\"padding: 10px 5px 0px 5px\"><div><div style=\"margin: 10px; margin-bottom: 0px;\"><div class=\"row\"><div class=\"col-md-3\"><select ng-model=\"controller.filtro.tipo\" ng-change=\"controller.filtrarPesquisa()\" class=\"form-control inputDisabledModal\"><option ng-value=\"0\">Todos</option><option ng-value=\"1\">Produtos</option><option ng-value=\"2\">Serviços</option></select></div><div class=\"col-lg-9\" style=\"margin-bottom: 20px;\"><input type=\"text\" ng-model=\"controller.filtro.texto\" ng-change=\"controller.filtrarPesquisa()\" class=\"form-control inputDisabledModal\" placeholder=\"Pesquisar...\"></div></div></div></div><div style=\"margin-left: 10px;\"><div ng:repeat=\"p in controller.registros\"><div style=\"padding: 10px 0 10px; border-bottom: 1px solid #f1f1f1\"><div class=\"row\"><div class=\"col-md-12\"><table style=\"width: 100%;\"><tr><td style=\"width: 100px;\"><div><a href=\"{{p.foto}}\" target=\"_blank\"><img height=\"100px\" width=\"100px\" src=\"{{p.foto}}\"></a></div></td><td style=\"padding-left: 10px; vertical-align: top;\"><a style=\"font-weight: bold;\">{{p.nome}}</a><div>{{p.descricao}}</div><div style=\"font-weight: bold; padding-top: 5px;\">{{p.valorUnitarioTexto}}</div><div style=\"text-align: left; padding-top: 5px;\"><button class=\"btn btn-xs\" ng-class=\"p.tipo == 1 ? \'btn-success\' : \'btn-primary\'\" style=\"width: 90px; height: 18px; font-size: 11px;\">{{p.tipo == 1 ? \'Produto\' : \'Serviço\'}}</button></div></td></tr></table></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/gpe/requisicao/index.html","<div class=\"container\"><div class=\"wrapper wrapper-content ng-scope\" style=\"padding-top: 0px; padding-bottom: 0px;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-title gray-bg\"><h5><i class=\"fa fa-tag\"></i> Requisição de Projeto</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome do Solicitante <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"200\" ng-model=\"controller.registro.solicitante.nome\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"200\" ng-model=\"controller.registro.solicitante.email\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Celular</label> <input type=\"text\" mask=\"(99)99999-9999\" ng-model=\"controller.registro.solicitante.celular\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Telefone</label> <input type=\"text\" mask=\"(99)9999-9999\" ng-model=\"controller.registro.solicitante.telefone\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Ramal</label> <input type=\"text\" maxlength=\"10\" ng-model=\"controller.registro.solicitante.ramal\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Departamento <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"10\" ng-model=\"controller.registro.solicitante.departamento\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Gestor Direto</label> <input type=\"text\" maxlength=\"10\" ng-model=\"controller.registro.solicitante.gestor\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome do Projeto <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"200\" ng-model=\"controller.registro.nomeProjeto\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Objetivo do Projeto <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"200\" ng-model=\"controller.registro.objetivo\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Áreas Envolvidas <span class=\"red\">*</span></label> <textarea ng-model=\"controller.registro.areasEnvolvidas\" class=\"form-control\" rows=\"2\" maxlength=\"500\"></textarea></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Motivo/Origem da Demanda <span class=\"red\">*</span></label> <textarea ng-model=\"controller.registro.motivo\" class=\"form-control\" rows=\"2\" maxlength=\"500\"></textarea></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Descritivo do Projeto <span class=\"red\">*</span></label> <textarea ng-model=\"controller.registro.descricao\" class=\"form-control\" rows=\"5\" maxlength=\"2000\"></textarea></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"form-group\" style=\"text-align: right;\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"min-width: 240px;\" ng-click=\"controller.salvar()\"><i class=\"fa fa-arrow-right\"></i> Enviar Requisição</button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/servico/catalogo/index.html","<style>\r\n    .bigText {\r\n      font-size: 42px !important;\r\n      height: 80px;\r\n      text-align: center;\r\n    }\r\n</style><div class=\"container\"><div class=\"wrapper wrapper-content ng-scope\" style=\"padding-top: 0px; padding-bottom: 0px;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title gray-bg\"><h5><i class=\"fa fa-wrench\"></i> Catálogo de Serviços</h5></div><div class=\"ibox-content\" cg-busy=\"controller.consultaPromise\"><div><div style=\"margin: 10px; margin-bottom: 20px;\"><div class=\"row\"><div class=\"col-md-3\"><select class=\"form-control inputDisabledModal\"><option>Todas as Categorias</option></select></div><div class=\"col-md-5\"><input type=\"text\" class=\"form-control inputDisabledModal\" placeholder=\"Digite o serviço desejado...\"></div><div class=\"col-md-2\"><button class=\"btn btn-block btn-success\"><i class=\"fa fa-search\"></i> Pesquisar</button></div></div></div></div><div style=\"margin-left: 10px; margin-top: 30px;\"><div class=\"row\"><div class=\"col-md-9\"><b style=\"color: #1c84c6;\"><i class=\"fa fa-star\"></i> Serviços Populares</b></div></div></div><div style=\"margin-left: 10px;\" ng:repeat=\"p in controller.registrosPopulares\"><div class=\"forum-item\"><div class=\"row\"><div class=\"col-md-9\"><div class=\"forum-icon\" style=\"cursor: pointer;\"><i class=\"fa fa-ticket\"></i></div><a href=\"#/index/novo_ticket\" class=\"forum-item-title\">{{p.nome}}</a><div class=\"forum-sub-title\">{{p.descricao != \'\' ? p.descricao : p.nome}}</div></div></div></div></div><div style=\"margin-left: 10px; margin-top: 30px;\"><div class=\"row\"><div class=\"col-md-9\"><b style=\"color: #1c84c6;\"><i class=\"fa fa-arrow-right\"></i> Serviços Disponíveis</b></div></div></div><div style=\"margin-left: 10px;\" ng:repeat=\"p in controller.registros\"><div class=\"forum-item\"><div class=\"row\"><div class=\"col-md-9\"><div class=\"forum-icon\" style=\"cursor: pointer;\"><i class=\"fa fa-ticket\"></i></div><a href=\"#/index/novo_ticket\" class=\"forum-item-title\">{{p.nome}}</a><div class=\"forum-sub-title\">{{p.descricao != \'\' ? p.descricao : p.nome}}</div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/ticket/consultar/index.html","<div class=\"container\"><div class=\"wrapper wrapper-content ng-scope\" style=\"padding-top: 0px; padding-bottom: 0px;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\" cg-busy=\"controller.consultarPromise\"><div class=\"ibox-title gray-bg\"><h5><i class=\"fa fa-search\"></i> Consultar Solicitações</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Consulta por <span class=\"red\">*</span></label><select class=\"form-control inputDisabledModal\" ng-model=\"controller.filtro.tipoConsulta\"><option value=\"1\">Número do Ticket</option><option value=\"2\">Usuário de Rede</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\" ng-if=\"controller.filtro.tipoConsulta == \'1\'\"><label class=\"col-form-label\">Número do Ticket <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"20\" ng-model=\"controller.filtro.numeroTicket\" class=\"form-control\"></div><div class=\"form-group\" ng-if=\"controller.filtro.tipoConsulta == \'2\'\"><label class=\"col-form-label\">Usuário de Rede <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"20\" ng-model=\"controller.filtro.usuarioRede\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">&nbsp;</label> <button class=\"btn btn-md btn-success btn-block\" type=\"button\" ng-click=\"controller.consultar()\"><i class=\"fa fa-search\"></i> Pesquisar</button></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.tickets != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title gray-bg\"><h5><i class=\"fa fa-tags\"></i> Solicitações</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 180px;\">Número</th><th>Assunto</th><th style=\"width: 170px;\">Data da Solicitação</th><th style=\"width: 100px;\">Situação</th></tr></thead><tbody><tr ng:repeat=\"p in controller.tickets\"><td>#{{ p.numero }}</td><td>{{ p.solicitacao.assunto.nome }}</td><td>{{ p.dataCadastro | date: \'dd/MM/yyyy HH:mm\' }}</td><td><button ng-if=\"p.status == 1\" class=\"btn btn-xs btn-warning btn-rounded\" style=\"width: 155px;\">{{ p.statusDesc }}</button> <button ng-if=\"p.status == 2\" class=\"btn btn-xs btn-success btn-rounded\" style=\"width: 155px;\">{{ p.statusDesc }}</button> <button ng-if=\"p.status == 5\" class=\"btn btn-xs btn-primary btn-rounded\" style=\"width: 155px;\">{{ p.statusDesc }}</button> <button ng-if=\"p.status == 8\" class=\"btn btn-xs btn-success btn-rounded\" style=\"width: 155px;\">{{ p.statusDesc }}</button> <button ng-if=\"p.status == 9\" class=\"btn btn-xs btn-success btn-rounded\" style=\"width: 155px;\">{{ p.statusDesc }}</button></td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.ticket != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title gray-bg\"><h5><i class=\"fa fa-tag\"></i> Informações do Ticket</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número do Ticket</label> <input type=\"text\" disabled=\"\" ng-model=\"controller.ticket.numero\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Solicitação</label> <input type=\"text\" disabled=\"\" value=\"{{controller.ticket.dataCadastro | date: \'dd/MM/yyyy HH:mm\'}}\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Serviço</label> <input type=\"text\" disabled=\"\" ng-model=\"controller.ticket.solicitacao.assunto.nome\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Situação Atual</label> <input type=\"text\" disabled=\"\" ng-model=\"controller.ticket.statusDesc\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\" style=\"display: none;\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Avalie este Atendimento</label><div style=\"font-size: 26px;\"><i ng-class=\"controller.avaliacao >= 1 ? \'fa fa-star yellow\' : \'fa fa-star-o\'\" ng-click=\"controller.setAvaliacao(1)\"></i> <i ng-class=\"controller.avaliacao >= 2 ? \'fa fa-star yellow\' : \'fa fa-star-o\'\" ng-click=\"controller.setAvaliacao(2)\"></i> <i ng-class=\"controller.avaliacao >= 3 ? \'fa fa-star yellow\' : \'fa fa-star-o\'\" ng-click=\"controller.setAvaliacao(3)\"></i> <i ng-class=\"controller.avaliacao >= 4 ? \'fa fa-star yellow\' : \'fa fa-star-o\'\" ng-click=\"controller.setAvaliacao(4)\"></i> <i ng-class=\"controller.avaliacao >= 5 ? \'fa fa-star yellow\' : \'fa fa-star-o\'\" ng-click=\"controller.setAvaliacao(5)\"></i></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/ticket/novo/index.html","<div class=\"container\"><div class=\"wrapper wrapper-content ng-scope\" style=\"padding-top: 0px; padding-bottom: 0px;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\" cg-busy=\"controller.salvarPromise\"><div class=\"ibox-title gray-bg\"><h5><i class=\"fa fa-ticket\"></i> Abertura de Ticket</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome do Solicitante <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"200\" ng-model=\"controller.ticket.solicitante.nome\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail <span class=\"red\">*</span></label><div class=\"input-group\"><input type=\"text\" maxlength=\"200\" ng-model=\"controller.ticket.solicitante.email\" class=\"form-control\"> <span ng-click=\"controller.verificarEmail()\" class=\"input-group-addon\" style=\"background-color: #18a689 !important; color: white\"><i class=\"fa fa-check\"></i></span></div></div></div></div><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Celular</label> <input type=\"text\" mask=\"(99)99999-9999\" ng-model=\"controller.ticket.solicitante.celular\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Telefone <span class=\"red\">*</span></label> <input type=\"text\" mask=\"(99)9999-9999\" ng-model=\"controller.ticket.solicitante.telefone\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Ramal</label> <input type=\"text\" maxlength=\"10\" ng-model=\"controller.ticket.solicitante.ramal\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Usuário de Rede <span class=\"red\">*</span></label><div class=\"input-group\"><input type=\"text\" maxlength=\"200\" ng-model=\"controller.ticket.solicitante.usuarioRede\" class=\"form-control\"> <span ng-click=\"controller.verificarUsuarioRede()\" class=\"input-group-addon\" style=\"background-color: #18a689 !important; color: white\"><i class=\"fa fa-check\"></i></span></div></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Serviço <span class=\"red\">*</span></label> <button ng-click=\"controller.selecionarAssunto()\" class=\"btn btn-block btn-success\"><i ng-if=\"controller.ticket.assunto == null\" class=\"fa fa-search\"></i> {{controller.ticket.assunto != null ? controller.ticket.assunto.nome : \'Selecionar Serviço\'}}</button></div></div></div><section id=\"_campos\"></section><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Localidade <span class=\"red\">*</span></label><select class=\"form-control\" ng-model=\"controller.ticket.localidade\" ng-change=\"controller.atualizarDepartamentos()\" ng-options=\"item as item.descricao for item in controller.localidades\"></select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Departamento <span class=\"red\">*</span></label><select class=\"form-control\" ng-model=\"controller.ticket.departamento\" ng-options=\"item as item.nome for item in controller.departamentos\"></select></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Descrição <span class=\"red\">*</span></label> <textarea ng-model=\"controller.ticket.descricao\" class=\"form-control\" rows=\"5\" maxlength=\"2000\"></textarea></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"form-group\" style=\"text-align: right;\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"min-width: 240px;\" ng-click=\"controller.salvar()\"><i class=\"fa fa-arrow-right\"></i> Registrar Ticket</button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/ticket/novo/sucesso.html","<style>\r\n    .bigText {\r\n      font-size: 42px !important;\r\n      height: 80px;\r\n      text-align: center;\r\n    }\r\n</style><div class=\"container\"><div class=\"wrapper wrapper-content ng-scope\" style=\"padding-top: 0px; padding-bottom: 0px;\"><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title gray-bg\"><h5><i class=\"fa fa-search\"></i> Ticket</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><br><label class=\"col-form-label\"><h2>Sua solicitação foi enviada para o departamento responsável.</h2></label></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\" style=\"margin-bottom: 0px;\"><label class=\"col-form-label\"><h2>Número do Ticket</h2></label><br><input type=\"text\" disabled=\"\" value=\"{{controller.ticketNumero}}\" class=\"form-control inputDisabledModal bigText\"><br><br><br><button class=\"btn btn-success\" ng-click=\"controller.consultarSituacao()\" style=\"width: 240px;\"><i class=\"fa fa-search\"></i> Consultar Situação</button></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.ticket != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins b-xs\"><div class=\"ibox-title gray-bg\"><h5><i class=\"fa fa-tag\"></i> Informações do Ticket</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número do Ticket</label> <input type=\"text\" disabled=\"\" ng-model=\"controller.ticket.numero\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Solicitação</label> <input type=\"text\" disabled=\"\" value=\"{{controller.ticket.dataCadastro | date: \'dd/MM/yyyy HH:mm\'}}\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Serviço</label> <input type=\"text\" disabled=\"\" ng-model=\"controller.ticket.solicitacao.assunto.nome\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Situação do Ticket</label> <input type=\"text\" disabled=\"\" ng-model=\"controller.ticket.statusDesc\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/ticket/modal/selecionar_assunto/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Selecionar Serviço</h5><small class=\"font-bold\">Selecione o serviço apropriado para a abertura de um Ticket.</small></div><div class=\"modal-body\" style=\"padding: 15px; padding-top: 20px;\"><div class=\"row\"><div class=\"col-lg-12\"><label class=\"col-form-label\">Pesquisar serviços:</label> <input ng-model=\"controller.filtro.pesquisa\" ng-change=\"controller.filtrarPesquisa()\" class=\"form-control\" placeholder=\"Digite para pesquisar o serviço...\"></div></div><div class=\"row\"><div class=\"col-lg-12\" cg-busy=\"controller.consultaPromise\" style=\"margin-bottom: 10px; margin-top: 20px;\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Serviço</th></tr></thead><tbody cg-busy=\"controller.listarPromise\" style=\"background-color: white;\"><tr ng:repeat=\"p in controller.items\"><td>{{ p.categoria.nome }} - {{ p.nome }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.selecionar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-check\"></i> Selecionar</button></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\" style=\"padding-top: 10px;\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-warning\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/ticket/custom/projeto_bi/index.html","<div class=\"container\"><div class=\"wrapper wrapper-content ng-scope\" style=\"padding-top: 0px; padding-bottom: 0px;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title gray-bg\" ng-click=\"controller.showhide(\'iconBoxAtendimento\', \'boxAtendimento\')\"><h5><i class=\"fa fa-comments\"></i> Projeto</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxAtendimento\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxAtendimento\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome do Projeto</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.nome\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo de Projeto</label><select class=\"form-control\" ng-model=\"controller.registro.tipo\"><option ng-value=\"1\">Departamental</option><option ng-value=\"2\">Corporativo</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Objetivo do Projeto</label> <textarea ng-model=\"controller.registro.descricao\" class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" rows=\"4\" maxlength=\"500\" placeholder=\"\" aria-invalid=\"false\">\r\n                                    </textarea></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Motivo/Origem da Demanda</label> <textarea ng-model=\"controller.registro.motivoDemanda\" class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" rows=\"2\" maxlength=\"500\" placeholder=\"\" aria-invalid=\"false\">\r\n                                    </textarea></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Áreas Envolvidas</label> <textarea ng-model=\"controller.registro.areasEnvolvidas\" class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" rows=\"2\" maxlength=\"500\" placeholder=\"\" aria-invalid=\"false\">\r\n                                    </textarea></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Classificação do Projeto</label><select class=\"form-control\" ng-model=\"controller.registro.classificacao\"><option ng-value=\"1\">Vital (afeta diretamente o cliente)</option><option ng-value=\"2\">Muito Importante (afeta a imagem da empresa)</option><option ng-value=\"3\">Importante (os que não se enquadram nos anteriores)</option><option ng-value=\"4\">Produção (sistemas de apoio a produção)</option></select></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title gray-bg\" ng-click=\"controller.showhide(\'iconBoxSolicitante\', \'boxSolicitante\')\"><h5><i class=\"fa fa-user\"></i> Solicitante</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxSolicitante\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxSolicitante\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Área</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.solicitanteArea\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Gestor</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.solicitanteGestor\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Contato</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.solicitanteContato\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Escopo de Atuação</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.solicitanteEscopoAtuacao\" placeholder=\"\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title gray-bg\" ng-click=\"controller.showhide(\'iconBoxGestoraInfo\', \'boxGestoraInfo\')\"><h5><i class=\"fa fa-user\"></i> Gestora da Informação</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxGestoraInfo\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxGestoraInfo\" class=\"ibox-content\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Área</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.gestoraInfoArea\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Gestor</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.gestoraInfoGestor\" placeholder=\"\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Contato</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.gestoraInfoContato\" placeholder=\"\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Escopo de Atuação</label> <input type=\"text\" maxlength=\"50\" ng-model=\"controller.registro.gestoraInfoEscopoAtuacao\" placeholder=\"\" class=\"form-control\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding: 10px;\"><button class=\"btn btn-success\" style=\"width: 200px;\"><i class=\"fa fa-send\"></i> Enviar Solicitação</button></div></div></div></div></div></div>");}]);